var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51733 5.629V16.3802L6.89292 11.0046L1.51733 5.629ZM2.58547 4.55176L9.39106 11.3573C10.2506 12.2169 11.7496 12.2169 12.6091 11.3573L19.4147 4.55176H2.58547Z",
    fill: "#0047AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6817 12.4299C12.9663 13.1461 12.0135 13.5413 11 13.5413C9.98648 13.5413 9.03365 13.1461 8.31828 12.4299L7.96552 12.0772L2.59448 17.4482H19.4055L14.0345 12.0772L13.6817 12.4299ZM15.1072 11.0045L20.4828 16.3801V5.62891L15.1072 11.0045Z",
    fill: "#0047AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c8cbfee42460cfa47ecad14264f16fcd.svg";
export { ForwardRef as ReactComponent };